import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { StatusCell } from "@/components/status/cell";
import { getUserFields } from "components/user/config";
import { EmployeeCell } from "components/cell/employee/cell";

export default function Departments() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
        {
            id: "head",
            header: "Head",
            accessorKey: "head",
            cell: EmployeeCell,
        },
        {
            header: "Coordinators",
            id: "coordinators",
            meta: {
                subRowAccessor: true,
            },
            cell: ({ row }) => {
                const coordinators = row.original?.coordinators;
                if (!coordinators || coordinators.length === 0) return null;
                return (
                    <div className="flex -space-x-1.5 overflow-hidden">
                        {coordinators?.map((coordinatorData) => (
                            <EmployeeCell key={coordinatorData.coordinator.id} getValue={() => coordinatorData.coordinator} />
                        ))}
                    </div>
                );
            },
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
    ];

    const fields = ["id", "name", "status", getUserFields("head"), getUserFields("coordinators.coordinator")];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="departments"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Departments</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Departments"
                    endPoint="departments"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="name"
                    sortOrder="aesc"
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
